export default __webpack_public_path__ + "static/media/Trackers-Active.23bf40c2.png";